import Tag from '@modules/common/components/tag';
import Text from '@modules/common/components/text';
import { RichContent } from '@modules/common/components/rich-content';
import type { PriceChangedContent } from '@lib/context/confirm-modal-context';

interface PriceChangedConfirmProps {
  priceChangedContent: PriceChangedContent | null;
}

/**
 * Format date for display
 */
const formatDate = (dateString: string): string => {
  const date = new Date(dateString);
  return date.toLocaleDateString('zh-TW', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
};

const PriceChangedConfirm = ({ priceChangedContent }: PriceChangedConfirmProps) => {
  if (!priceChangedContent) return null;

  return (
    <div
      className="flex flex-col gap-2 lg:max-h-[800px] lg:pr-6"
      data-testid="confirm-modal-price-changed-container"
    >
      <Text variant="title-bold" as="h3" className="text-black-20">價格調整公告</Text>
      <Text variant="sm-regular" as="div" className="text-grey-10">
        {formatDate(priceChangedContent.updatedAt)}
      </Text>
      <div className="mb-4 mt-2">
        <Tag
          text="價格異動"
          className="bg-blue-30_op10 text-blue-30 rounded-full px-4 py-2 font-normal"
        />
      </div>
      <div className="prose prose-sm text-grey-60 max-w-none">
        <RichContent nodes={priceChangedContent.content} />
      </div>
    </div>
  );
};

export default PriceChangedConfirm;
